<template>
  <div class="component-container">
    <label v-if="showLabel()" :style="lableStyle"
      ><span class="xing" :style="required ? { color: '#f00' } : null">*</span
      >{{ label }}</label
    >
    <div :style="imgstyle">
      <div v-if="showVideo()" class="music-container">
        <!-- <el-tooltip :content="musicName" placement="top-start">
          <span class="music-name">{{ musicName }}</span>
        </el-tooltip> -->
        <!-- <el-tooltip
          v-if="playing"
          :content="tooltipForPause"
          placement="top-start"
        >
          <i class="el-icon-video-pause el-icon-action" @click="handlePause" />
        </el-tooltip>-->

        <span style="margin-right: 20px" @click="handlePlay" class="preview">
          <b>预览</b>
          <i class="el-icon-video-play el-icon-action" />
        </span>

        <span @click="handleDelete" class="preview" v-if="isedite">
          <i class="el-icon-delete el-icon-action" />
          <b>删除</b>
        </span>
      </div>
      <el-tooltip
        v-else-if="isedite"
        popper-class="image-tip"
        :disabled="disabledTooltip() || !isedite"
        :content="tooltip"
        placement="top-start"
      >
        <el-upload
          class="upload-btn"
          list-type="text"
          :show-file-list="false"
          :action="uploadAction"
          :disabled="!isedite || videoloading"
          :on-progress="handlProgress"
          :on-error="handelerr"
          :timeout="0"
          accept="video/*"
          :on-success="handleUploadSuccess"
          :before-upload="handleBeforeUpload"
          ref="uploader"
        >
          <!-- <i class="el-icon-plus"></i> -->
          <div class="icon-wrap-container">
            <div v-if="videoloading" class="inpro">
              <el-progress
                :percentage="progress"
                :stroke-width="22"
                :text-inside="true"
                style="width: 100%"
              ></el-progress>
              <el-button size="mini" type="danger" @click="handelstop"
                >取消</el-button
              >
            </div>
            <i class="el-icon-plus uploader-icon" v-else />
          </div>
        </el-upload>
      </el-tooltip>
    </div>
    <el-dialog
      :visible.sync="dialogVisible"
      :show-close="false"
      :top="'5vh'"
      :close-on-click-modal="false"
      :destroy-on-close="true"
    >
      <video :src="src" controls style="width: 100%"></video>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handelclose">关 闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import _ from 'lodash'
import Validator from '../../utils/validator'

export default {
  name: 'jtVideo',
  props: {
    label: {
      type: String,
      default: '',
    },
    labelWidth: {
      type: String,
      default: '30%',
    },
    src: {
      type: String,
      default: '',
    },
    videoName: {
      type: String,
      default: '',
    },
    width: {
      type: String,
      default: '200px',
    },
    height: {
      type: String,
      default: '30px',
    },
    uploadAction: {
      type: String,
      default: '',
    },
    tooltip: {
      type: String,
      default: '',
    },
    supportTypes: {
      type: Array,
      default: () => ['video/mp4', 'video/quicktime'],
    },
    supportSize: {
      type: Array,
      default: [],
    },
    editable: {
      type: Boolean,
      default: true,
    },
    required: {
      type: Boolean,
      default: false,
    },
    alwaysEdit: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      lableStyle: {
        width: window.innerWidth > 768 ? this.labelWidth : '100%',
      },
      imgstyle: {
        width: window.innerWidth > 768 ? '500px' : '100%',
      },
      videoFrameStyle: {
        width: this.width,
        height: this.height,
      },
      uploadStyle: {
        width: this.width,
        height: this.height,
      },
      tooltipForPause: this.$t('video.PAUSE'),
      tooltipForPlay: this.$t('video.PLAY'),
      tooltipForDelete: this.$t('video.DELETE'),
      playing: false,
      audio: null,
      videoloading: false,
      progress: 0,
      dialogVisible: false,
    }
  },
  computed: {
    isedite() {
      if (this.alwaysEdit) {
        return true
      } else {
        return this.editable
      }
    },
  },
  methods: {
    showLabel() {
      return !_.isEmpty(_.trim(this.label))
    },
    showVideo() {
      return !_.isEmpty(this.src)
    },
    // newuploadAction() {
    //   let newaction = 'http://upload.justtool.com' + this.uploadAction
    //   return newaction
    // },
    disabledTooltip() {
      return _.isEmpty(_.trim(this.tooltip))
    },
    handleEndedEvent() {
      this.playing = false
    },
    handlProgress(event, file) {
      this.progress = parseInt(file.percentage)
    },
    handelerr(err, file) {
      this.$message.error('上传失败')
      this.videoloading = false
      this.progress = 0
    },

    handlePlay() {
      this.dialogVisible = true
    },
    handelclose() {
      this.dialogVisible = false
    },
    handelstop() {
      this.$refs.uploader.abort()
      setTimeout(() => {
        this.progress = 0
        this.videoloading = false
      }, 500)
    },

    handleDelete() {
      const msg = this.$t('image.CONFIRM_FOR_DELETE')
      const title = this.$t('global.TIPS')
      this.$confirm(msg, title, {
        confirmButtonText: this.$t('page.SUBMIT_CONFIRM_OK'),
        cancelButtonText: this.$t('page.SUBMIT_CONFIRM_CANCEL'),
      })
        .then(() => {
          this.$emit('delete')
          this.videoloading = false
          this.progress = 0
        })
        .catch(() => {})
    },
    handleUploadSuccess(response, file, fileList) {
      this.$emit('success', response.payload)
      this.videoloading = false
    },
    async handleBeforeUpload(file) {
      try {
        this._validate(file)
        this.videoloading = true
        return true
      } catch (err) {
        const title = this.$t('global.ERROR')
        await this.$alert(err.message, title, {
          type: 'error',
          showClose: false,
        })

        throw err
      }
    },
    _validate(file) {
      let errMsg = this.$t('video.SUPPORT_VIDEO_TYPE', {
        videoType: _.join(this.supportTypes),
      })
      Validator.isSupportFileType(file.type, this.supportTypes, errMsg)
      let errMsg1 = this.$t('video.SUPPORT_VIDEO_SIZE', {
        videoSize:
          this.supportSize.length === 2
            ? this.supportSize[1] / 1024 / 1024
            : this.supportSize[0] / 1024 / 1024,
      })
      let errMsg2 = this.$t('video.MIN_VIDEO_SIZE', {
        videoSize: this.supportSize[0] / 1024 / 1024,
      })
      Validator.isSupportFileSize(file.size, this.supportSize, errMsg1, errMsg2)
    },
  },
}
</script>

<style lang="stylus" scoped>
.component-container {
  display: flex;
  flex-direction: row;
  align-items: baseline;
}

.music-container {
  // border: 1px dashed #333;
  padding: 5px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  background-color: #b4ff8f;
}

.music-name {
  width: 70%;
}

.el-icon-action {
  color: black;
  cursor: pointer;
}

.upload-btn {
  padding: 5px;
  // width: 100%;
  border: 1px dashed #333;
}

.upload-btn >>>.el-upload {
  display: block;
}

.icon-wrap-container {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}

.uploader-icon {
  font-size: 28px;
  color: #333;
  cursor: pointer;
}

.image-tip {
  max-width: 200px;
}

.src {
  color: #5daf34;
  margin-right: 20px;

  sub {
    color: #505050;
  }
}

.component-container >>> .el-dialog {
  max-width: 600px;
}

.el-icon-action {
  font-size: 30px;
}

.inpro {
  display: flex;
  width: 100%;
}

.preview {
  display: flex;
  align-items: center;
}
</style>
